import Slider from "./Slider";

import { SwiperOptions, Navigation, FreeMode } from "swiper";

// Snapshot tailwind config with babel-plugin-preval
const tailwindScreens = preval`
    const resolveConfig = require('tailwindcss/resolveConfig');
    const tailwindConfig = require('./../../../tailwind.config.js');

    const fullConfig = resolveConfig(tailwindConfig)
    module.exports = fullConfig.theme.screens;
`;


export default class extends Slider {
    constructor(m) {
        super(m);

        this.nav = this.$('nav')[0];

        let offset = 88;
        if (this.nav && this.nav.clientWidth) {
            offset = this.nav.clientWidth;
        }

        /** @type {SwiperOptions} */
        this.config = {
            // Optional parameters
            modules: [Navigation, FreeMode],
            slidesPerView: 'auto',
            speed: 500,
            pagination: null,
            freeMode: {
                enabled: true,
                // momentum: true,
                // minimumVelocity: 0.04,
                // momentumVelocityRatio: 0.5
            },
            breakpoints: {
                [parseInt(tailwindScreens.md)]: {
                    slidesOffsetBefore: offset,
                    freeMode: false
                }
            },
            on: {
                init: this.toggleNavigationBySize,
                resize: this.toggleNavigationBySize,
                setTranslate: (swiper, translate) => {
                    this.slides.forEach(slide => {
                        slide.classList.toggle('-is-outside-prev', translate < 0 && (Math.abs(translate) > slide.offsetLeft + 0));
                    });
                },
            }
        }
    }
    
    bindEvents(el) {}

    update(newContainer) {}

    destroy(oldContainer) {}
}
